export function getApiErrorMessage(error, fallbackMessage) {
  const responseData = error && error.response && error.response.data;
  const responseMessage =
    responseData && typeof responseData === 'object'
      ? responseData.error || responseData.message
      : responseData;

  return typeof responseMessage === 'string' && responseMessage.trim()
    ? responseMessage
    : fallbackMessage;
}

export function notifyApiError(showFlashNotification, error, fallbackMessage) {
  const message = getApiErrorMessage(error, fallbackMessage);
  showFlashNotification(message, 'error');
  return message;
}
